import { useState, useEffect } from 'react';
import { calculateFreeShippingProgress, formatCurrencyByCountry } from '../utils/freeShippingCalculator';
import useLocation from './useLocation';

export const useFreeShipping = (cartSubtotal) => {
  const { currentIsoCode, isLoading: locationLoading } = useLocation();
  const [shippingData, setShippingData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!locationLoading && cartSubtotal !== undefined) {
      const calculatedData = calculateFreeShippingProgress(cartSubtotal, currentIsoCode);
  
      const formattedData = {
        ...calculatedData,
        formattedAmountLeft: formatCurrencyByCountry(calculatedData.amountLeft, currentIsoCode),
        formattedThreshold: formatCurrencyByCountry(calculatedData.threshold, currentIsoCode),
        formattedCartSubtotal: formatCurrencyByCountry(calculatedData.cartSubtotal, currentIsoCode),
      };
      
      setShippingData(formattedData);
      setIsLoading(false);
    }
  }, [cartSubtotal, currentIsoCode, locationLoading]);

  return {
    shippingData,
    isLoading: isLoading || locationLoading
  };
};